export const LOGIN_ENDPOINT = 'auth';
export const GOOGLE_AUTHORIZATION_CODE_ENDPOINT = 'authcode';
export const GOOGLE_REFRESH_TOKEN_ENDPOINT = 'tokenrefresh';
